<template>
  <div class="detail"> 
    <div class="re">
      <el-button class="btn" @click="clickreturn">返回</el-button>
      <el-button class="btn" @click="saveAllEdits">保存</el-button>
    </div>
    <div class="top-table">
            <el-descriptions
              v-for="item in datalist"
              :key="item.id"
              title="Product Information"
              :column="5"
              :size="size"
              direction="vertical"
              :style="blockMargin"
            >
              <el-descriptions-item label="名称" :span="2">
                <div v-if="item.isEditing">
                  <el-input v-model="item.name" size="small" />
                </div>
                <div v-else>
                  {{ item.name }}
                </div>
              </el-descriptions-item>

              <el-descriptions-item label="简称" :span="2" v-if="isnews">
                <div v-if="item.isEditing">
                  <el-input v-model="item.shortName" size="small" />
                </div>
                <div v-else>
                  {{ item.shortName }}
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="简称" :span="4" v-if="!isnews">
                <div v-if="item.isEditing">
                  <el-input v-model="item.shortName" size="small" />
                </div>
                <div v-else>
                  {{ item.shortName }}
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="newsTime" :span="2" v-if="isnews">
                <div v-if="item.isEditing">
                 <el-date-picker
                  v-model="item.newsTime"
                  type="datetime"
                  placeholder="选择日期和时间"
                  size="small"
                  value-format="YYYY-MM-DD HH:mm:ss"
                />
                </div>
                <div v-else>
                  {{ formatNewsTime(item.newsTime) }}
                </div>
              </el-descriptions-item>

              <!-- <el-descriptions-item label="操作" :span="1">
                <el-button size="small" type="primary" @click="toggleEdit(item)">
                  编辑
                </el-button>
                <el-button v-if="item.isEditing" size="small" @click="cancelEdit(item)">
                  取消
                </el-button>
              </el-descriptions-item> -->

              <!-- 第二行：banner链接（2格）+ 缩略图链接（3格） -->
              <el-descriptions-item label="banner链接" :span="2">
                <div v-if="item.isEditing">
                  <el-upload
                    :show-file-list="false"
                    :http-request="(options) => handleSingleImageUpload(options, 'banner链接')"
                  >
                    <img
                      :src="item.banner"
                      style="width: 100px; cursor: pointer;"
                      alt="banner图片预览"
                    />
                  </el-upload>
                </div>
                <div v-else>
                  <div>{{ item.banner }}</div>
                  <img
                    :src="item.banner"
                    style="width: 100px;"
                    alt="banner图片预览"
                  />
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="mbanner链接" :span="2">
                <div v-if="item.isEditing">
                  <el-upload
                    :show-file-list="false"
                    :http-request="(options) => handleSingleImageUpload(options, 'mbanner链接')"
                  >
                    <img
                      :src="item.mbanner"
                      style="width: 100px; cursor: pointer;"
                      alt="mbanner图片预览"
                    />
                  </el-upload>
                </div>
                <div v-else>
                  <div>{{ item.mbanner}}</div>
                  <img
                    :src="item.mbanner"
                    style="width: 100px;"
                    alt="mbanner图片预览"
                  />
                </div>
              </el-descriptions-item>

              <el-descriptions-item label="缩略图链接" :span="2">
                <div v-if="item.isEditing">
                  <el-upload
                    :show-file-list="false"
                    :http-request="(options) => handleSingleImageUpload(options, '缩略图链接', 'thumbnail')"
                  >
                    <img
                      :src="item.thumbnail"
                      style="width: 100px; cursor: pointer;"
                      alt="缩略图预览"
                    />
                  </el-upload>
                </div>
                <div v-else>
                  <div>{{ item.thumbnail }}</div>
                  <img
                    :src="item.thumbnail"
                    style="width: 100px;"
                    alt="缩略图预览"
                  />
                </div>
              </el-descriptions-item>


              <!-- 第三行：产品描述（占满整行） -->
              <el-descriptions-item label="描述" :span="24">
                <div v-if="item.isEditing">
                  <el-input v-model="item.description" size="small" type="textarea" />
                </div>
                <div v-else>
                  {{ item.description }}
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="产品名称" :span="24">
                <div v-if="item.isEditing">
                  <el-input v-model="item.description" size="small" type="textarea" />
                </div>
                <div v-else>
                  {{ item.description }}
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="解决方案名称" :span="24">
                <div v-if="item.isEditing">
                  <el-input v-model="item.description" size="small" type="textarea" />
                </div>
                <div v-else>
                  {{ item.description }}
                </div>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <el-table ref="tableRef" :data="data" style="width: 100%" row-key="id"
    @row-dragend="handleDragEnd">
              <el-table-column label="类型" align="left" width="150">
                <template #default="scope">
                <div v-if="scope.row.isEditing">
                  <el-select v-model="scope.row.itemType" placeholder="选择类型" size="small">
                    <el-option v-for="(label, value) in itemTypeMap" :key="value" :label="label" :value="Number(value)" />
                  </el-select>
                </div>
                <div v-else>
                  {{ formatItemType(scope.row) }}
                </div>
              </template>
              </el-table-column>
                <el-table-column label="值" align="center" min-width="200" style="display: flex; align-items: center;" >
                <template #default="scope">
                  <div v-if="scope.row.isEditing">
                    <!-- 视频类型：显示上传按钮和视频预览 -->
                    <div v-if="scope.row.itemType === 3">
                      <el-upload
                        :show-file-list="false"
                        :http-request="(options) => customUpload(options, scope.row)"
                      >
                        <el-button size="small">上传视频</el-button>
                      </el-upload>
                      <video
                        v-if="scope.row.itemContent"
                        :src="scope.row.itemContent"
                        accept="video/*"
                        controls
                        style="width: 200px; margin-top: 10px;"
                      ></video>
                    </div>

                    <!-- 图片类型 -->
                    <div v-else-if="scope.row.itemType === 4 || scope.row.itemType === 5">
                      <el-upload
                        :file-list="scope.row.fileList"
                        list-type="picture-card"
                        :on-remove="(file, fileList) => handleRemove(file, fileList, scope.row)"
                        :http-request="(options) => customUpload(options, scope.row)"
                      >
                        <el-icon><Plus /></el-icon>
                      </el-upload>
                    </div>
                    <!-- 带点列表类型 -->
                    <div v-else-if="scope.row.itemType === 7" class="input-container">
                      <el-input 
                        v-model="scope.row.itemContent" 
                        size="small" 
                        type="textarea" 
                        style="height: 12em!important;" 
                        rows="6"
                        placeholder="请输入列表内容，每行一个列表项"
                      />
                      <div style="color: #999; font-size: 12px; margin-top: 4px;">提示：每行输入一个列表项</div>
                    </div>
                    <!-- <div v-else-if="scope.row.itemType === 8 && scope.row.itemContent" class="core-features">
                      <div v-for="(feature, index) in parseFeatures(scope.row.itemContent)" :key="index" class="feature-block">
                      <h4 class="feature-title">{{ feature.title }}</h4>
                      <ul class="feature-list">
                        <li v-for="(item, itemIndex) in feature.valueList" :key="itemIndex">{{ item }}</li>
                      </ul>
                      </div>
                    </div> -->
                    <template v-else-if="scope.row.itemType === 8">
                      <div class="core-feature-editor">
                        <div class="feature-list">
                          <div v-for="(feature, featureIndex) in scope.row.features || []" :key="featureIndex" class="feature-item">
                            <el-input 
                              v-model="feature.title" 
                              placeholder="请输入功能标题"
                              style="margin-bottom: 8px;"
                            />
                            <el-input 
                              type="textarea" 
                              v-model="feature.valueList" 
                              placeholder="请输入功能描述，多个项目用分号分隔"
                              :rows="2"
                              style="margin-bottom: 8px;"
                            />
                            <el-button 
                              type="danger" 
                              size="small" 
                              @click="removeFeature(scope.row, featureIndex)"
                              style="margin-bottom: 16px;"
                            >
                              删除功能
                            </el-button>
                          </div>
                        </div>
                        <el-button type="primary" size="small" @click="addFeature(scope.row)">
                          添加功能
                        </el-button>
                      </div>
                    </template>
                    <!-- 文本类型 -->
                    <div v-else class="input-container">
                      <el-input v-model="scope.row.itemContent" size="small" type="textarea" style="height: 12em!important;" rows="6"/>
                    </div>
                  </div>
                  <div v-else>
                    <!-- 视频展示 -->
                    <div v-if="scope.row.itemType === 3 && scope.row.itemContent">
                      <video
                        :src="scope.row.itemContent"
                        controls
                        style="width: 200px;"
                      ></video>
                    </div>

                    <!-- 单图片展示 -->
                    <div v-else-if="scope.row.itemType === 4 && scope.row.itemContent">
                      <img
                        :src="scope.row.itemContent"
                        style="width: 100px;"
                        alt="图片预览"
                      />
                    </div>

                    <!-- 多图片展示 -->
                    <div v-else-if="scope.row.itemType === 5 && scope.row.itemContent">
                      <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                        <img
                          v-for="(url, index) in scope.row.itemContent.split(';')"
                          :key="index"
                          :src="url"
                          style="width: 100px;"
                          alt="图片预览"
                        />
                      </div>
                    </div>

                    <!-- 文本展示 -->
                    <div v-else>
                      {{ scope.row.itemContent }}
                    </div>
                  </div>

                </template>
              </el-table-column>

              <el-table-column label="操作" align="right" width="100">
                <template #default="scope">
                  <!-- <el-button size="small" type="primary" @click="toggleEdit(scope.row)">
                    编辑
                  </el-button> -->
                  <el-button size="small" type="danger" @click="handleDelete(scope.row)">
                    删除
                  </el-button>
                </template>
              </el-table-column>
          </el-table>
          <!-- <template v-if="newItemVisible">
              <el-card style="margin-top: 1em;">
                <div style="display: flex; align-items: center; gap: 20px; flex-wrap: wrap;">

                  <el-select v-model="newItem.itemType" placeholder="选择类型" size="small">
                    <el-option v-for="(label, value) in itemTypeMap" :key="value" :label="label" :value="Number(value)" />
                  </el-select>

                  
                  <template v-if="newItem.itemType === 3">
                    
                    <el-upload :show-file-list="false" :http-request="handleNewUpload">
                      <el-button size="small">上传视频</el-button>
                    </el-upload>
                    <video v-if="newItem.itemContent" :src="newItem.itemContent" controls style="width: 200px;" />
                  </template>

                  <template v-else-if="newItem.itemType === 4 || newItem.itemType === 5">
                    <el-upload
                      :file-list="newItem.fileList"
                      list-type="picture-card"
                      :on-remove="handleNewRemove"
                      :http-request="handleNewUpload"
                    >
                      <el-icon><Plus /></el-icon>
                    </el-upload>
                  </template>

                  <template v-else>
                    
                    <el-input v-model="newItem.itemContent" size="small" placeholder="请输入内容" style="width: 300px;" />
                  </template>

                  <el-button type="success" size="small" @click="confirmAdd">确认添加</el-button>
                  <el-button type="info" size="small" @click="cancelAdd">取消</el-button>
                </div>
              </el-card>
            </template> -->
          

          <div class="addbtn">
            <el-button @click="additem"><el-icon><Plus /></el-icon></el-button>
          </div>
  </div>
</template>

<script setup name="DetailPage">
import { useRoute,useRouter } from 'vue-router';
import { onMounted ,ref,onUnmounted,watch,nextTick} from 'vue';
import { detail } from '@/api/detail';
import { addText } from '@/api/Posttext';
import { uploadImage } from '@/api/upload';
import { ElMessage } from 'element-plus';
import dayjs from 'dayjs';
import Sortable from 'sortablejs'
const data = ref([]);
const datalist = ref([]);
const tableRef = ref(null);
const rowSortable = ref(null);
const route = useRoute();
const id = (route.query||{}).id;
const itemTypeMap = {
  1: '标题',
  2: '正文',
  3: '视频',
  4: '单图片',
  5: '多图片',
  6: '副标题',
  7: '带点列表',
  8: '核心功能',

};
const router = useRouter();
let isnews = false;
const getCoreFeatures = () => {
  if (!datalist.value.length || !datalist.value[0].items) return [];
  
  const coreFeatureItems = datalist.value[0].items.filter(item => item.itemType === 8);
  const features = [];
  
  coreFeatureItems.forEach(item => {
    try {
      // 如果 itemContent 已经是数组，直接使用
      const parsedFeatures = Array.isArray(item.itemContent) ? item.itemContent : JSON.parse(item.itemContent);
      parsedFeatures.forEach(feature => {
        features.push({
          title: feature.title,
          valueList: feature.valueList ? feature.valueList.split(';').filter(item => item.trim()) : []
        });
      });
    } catch (e) {
      console.error('解析核心功能数据失败:', e);
    }
  });
  
  return features;
};
// 初始化拖拽
const initRowSortable = () => {
  const tbody = tableRef.value?.$el.querySelector('.el-table__body-wrapper tbody');
  if (!tbody) return;
  
  // 销毁旧的实例
  if (rowSortable.value) {
    rowSortable.value.destroy();
  }

  // 创建新的拖拽实例
  rowSortable.value = Sortable.create(tbody, {
    animation: 150,
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    onEnd: async (evt) => {
      const { newIndex, oldIndex } = evt;
      if (newIndex === oldIndex) return;
      
      // 创建新数组避免直接修改
      const newData = [...data.value];
      const [movedItem] = newData.splice(oldIndex, 1);
      newData.splice(newIndex, 0, movedItem);
      
      // 更新数据
      data.value = newData;
      
      // 同步更新到datalist
      if (datalist.value[0]?.items) {
        datalist.value[0].items = [...newData];
      }
      
      // 立即更新UI
      await nextTick();
      tableRef.value?.doLayout();
      
      // 自动保存排序
      await saveSortOrder();
    }
  });
};
// 保存排序顺序
const saveSortOrder = async () => {
  try {
    // 更新排序序号
    data.value.forEach((item, index) => {
      item.sort = index + 1;
    });
    
    if (datalist.value[0]?.items) {
      datalist.value[0].items = [...data.value];
    }
    
    await addText(datalist.value[0]);
    console.log(datalist.value[0]);
    ElMessage.success('排序已保存');
  } catch (err) {
    console.error('保存排序失败', err);
    ElMessage.error('保存排序失败');
  }
};
const parseFeatures = (content) => {
  if (!content) return [];
  try {
    const features = JSON.parse(content);
    return features.map(feature => ({
      title: feature.title,
      valueList: feature.valueList ? feature.valueList.split(';').filter(item => item.trim()) : []
    }));
  } catch (e) {
    return [];
  }
};

const addFeature = (row) => {
  if (!row.features) {
    row.features = [];
  }
  row.features.push({
    title: '',
    valueList: ''
  });
};

const removeFeature = (row, index) => {
  if (row.features && row.features.length > index) {
    row.features.splice(index, 1);
  }
};

// 定义时间格式
function formatNewsTime(time) {
  if (time) {
    return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
  }
  return '';
}
function parseListContent(content) {
  if (!content) return [];
  return content.split('\n').filter(item => item.trim() !== '');
}
function formatItemType(row) {
  return itemTypeMap[row.itemType] || '未知类型';
}
function clickreturn() {
  router.push(`/backend?objectType=${datalist.value[0].objectType}`);
}
function handleSingleImageUpload(options, item) {
  const formData = new FormData();
  formData.append('file', options.file);
  console.log(formData);
  uploadImage(formData)
    .then(res => {
      if (res.code === 200) {
        if (item === '缩略图链接') {
          datalist.value[0].thumbnail = res.data;
        }
        else if (item === 'banner链接') {
          datalist.value[0].banner = res.data;
        }
        else if (item === 'mbanner链接') {
          datalist.value[0].mbanner = res.data;
        }
        console.log(res);
        ElMessage.success('上传成功');
      } else {
        ElMessage.error('上传失败');
      }
    })
    .catch(() => {
      ElMessage.error('上传出错');
    });
}

async function pagerender() {
  data.value = [];
  datalist.value = [];
  const datas = await detail(id);
  console.log(datas);
  console.log(datas.data.objectType);
  if(datas.data.objectType==='new'){
   isnews=true;
  }
  console.log('页面获取数据:',datas.data.items)
  datalist.value.push(datas.data);
  (datalist.value[0]||[]).isEditing = true;
  ((datas.data||{}).items || []).forEach(item => {
    var itemm=item||{}
    itemm.isEditing = true;
  console.log(itemm.itemContent);
  if (itemm.itemType===3 || itemm.itemType === 4 || itemm.itemType === 5 ) {
    itemm.fileList = itemm.itemContent
      ? itemm.itemContent.split(';').map((url, index) => ({
          name: `图片${index + 1}`,
          url,
        }))
      : [];
    }
  console.log(itemm.fileList);
  // 为核心功能准备可编辑的 features（把 JSON 解析成字符串值的 valueList，分号分隔）
  if (itemm.itemType === 8 && itemm.itemContent) {
    const parsed = parseFeatures(itemm.itemContent); // [{ title, valueList: [] }]
    itemm.features = parsed.map(f => ({
      title: f.title || '',
      valueList: Array.isArray(f.valueList) ? f.valueList.join(';') : (f.valueList || '')
    }));
  }
  data.value.push(itemm);
});

}

onMounted(() => {
  Startrender(false)
  pagerender();
  initRowSortable();
}); 
 onUnmounted(() => {
   Startrender(true)
   if (rowSortable.value) {
    rowSortable.value.destroy();
  }
 })
 // 在数据变化时重新初始化拖拽
watch(data, () => {
  nextTick(() => {
    initRowSortable();
    tableRef.value?.doLayout();
  });
}, { deep: true });


 const emit = defineEmits(['showlink'])
function Startrender(type) {
  console.log(type);
  emit('showlink', type)
}

async function saveAllEdits() {
  try {
    // 保存 datalist 的编辑状态（基本信息）
    // datalist.value.forEach(item => {
    //   if (item.isEditing) {
    //     item.isEditing = false;
    //   }
    // });
    console.log('更新后的data:',data.value)
    // 保存表格 data（内容项）
    data.value.forEach((row, index) => {
      row.sort = index + 1; // 更新排序序号
      if (row.isEditing) {
        // 更新 fileList 对应的 itemContent（用于图片类型）
        if (row.itemType === 4 || row.itemType === 5) {
          row.itemContent = row.fileList.map(f => f.url).join(';');
        }
        // 核心功能：将 features 序列化为 JSON 字符串存到 itemContent
        else if (row.itemType === 8) {
          const normalized = (Array.isArray(row.features) ? row.features : [])
            .map(f => {
              const list = Array.isArray(f.valueList)
                ? f.valueList
                : (f.valueList ? f.valueList.split(/[;\n]/).map(s => s.trim()).filter(Boolean) : []);
              return {
                title: (f.title || '').trim(),
                // 这里保持为分号分隔的字符串，前台渲染会 split(';')
                valueList: list.join(';')
              };
            })
            // 过滤掉空项（标题和值都为空的）
            .filter(f => f.title || f.valueList);

          row.itemContent = JSON.stringify(normalized);
        }

        // 把改动同步回 datalist[0].items
        const target = datalist.value[0].items.find(i => i.id === row.id);
        if (target) {
          target.itemContent = row.itemContent;
          target.fileList = row.fileList;
        }
        // row.isEditing = false;
      }
    });
    datalist.value[0].items = [...data.value];
    console.log('更新后的datalist:',datalist.value[0])
    await addText(datalist.value[0]);
    ElMessage.success('保存成功');
    console.log('提交数据：', datalist.value[0]);
    pagerender();
  } catch (err) {
    console.error('保存失败', err);
    ElMessage.error('保存失败');
  }
}

async function customUpload(options, row) {
  const formData = new FormData();
  formData.append('file', options.file);
  
 try {
    const res = await uploadImage(formData);
    if (res.code === 200) {
      const url = res.data;
      options.file.url = url;
      if (row.itemType === 3||row.itemType === 4) {
        row.itemContent = url;
        row.fileList = [options.file];
      } else if (row.itemType === 5) {
        row.itemContent += (row.itemContent ? ';' : '') + url;
        row.fileList.push(options.file);
      }
      console.log(row);

      ElMessage.success('上传成功');
      
    } else {
       ElMessage.error('上传失败');
    }
  } catch (err) {
    ElMessage.error('上传出错');
  }
}

function handleRemove(file, fileList, row) {
  row.fileList = fileList;
  row.itemContent = fileList.map(f => f.url).join(';');
}
//删除
function handleDelete(row) {
  const indexInData = data.value.findIndex(item => item.id === row.id);
  if (indexInData !== -1) {
    data.value.splice(indexInData, 1);
  }

  if (datalist.value.length > 0 && datalist.value[0].items) {
    const items = datalist.value[0].items;
    const indexInItems = items.findIndex(item => item.id === row.id);
    if (indexInItems !== -1) {
      items.splice(indexInItems, 1);
    }
  }
  try {
    addText(datalist.value[0]);
    ElMessage.success('删除成功');
    console.log('删除后数据:', datalist.value); 
  }
  catch (error) {
    ElMessage.error('删除失败');
  }
  console.log('删除后数据:', datalist.value);
}

//添加表格
// const newItemVisible = ref(false);
const newItem = ref({
  id: '', // 用当前时间戳作为唯一 ID
  itemType: 1,
  itemContent: '',
  fileList: [],
  isEditing: true,
});

function additem() {
  newItem.value = {
    itemType: 1,
    itemContent: '',
    fileList: [],
    isEditing: true,
  };
  data.value.push({ ...newItem.value });
  console.log('加入新数据后的data:',data.value);
  // newItemVisible.value = true;
}

async function confirmAdd() {
  // 构造新项
  const item = { ...newItem.value };
  if (item.itemType === 4 || item.itemType === 5) {
    item.itemContent = item.fileList.map(f => f.url).join(';');
  }

  data.value.push(item);
  datalist.value[0].items.push(item);
  try {
    await addText(datalist.value[0]);
    datalist.value=[];
    data.value=[];
    pagerender();
    ElMessage.success('添加成功');
  } catch (err) {
    console.error('添加失败', err);
    ElMessage.error('添加失败');
  }
  newItemVisible.value = false;
  ElMessage.success('添加成功');
}

function handleNewUpload(options) {
  customUpload(options, newItem.value);
}
function handleNewRemove(file, fileList) {
  newItem.value.fileList = fileList;
  newItem.value.itemContent = fileList.map(f => f.url).join(';');
}
function cancelAdd() {
  newItemVisible.value = false;
}

</script>

<style scoped>
/* 增强拖拽样式 */
.sortable-ghost {
  background: #f5f7fa !important;
  opacity: 0.8;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.sortable-chosen {
  background: #e6f7ff !important;
  box-shadow: 0 0 8px rgba(64, 158, 255, 0.3);
}

.sortable-drag {
  opacity: 1 !important;
  background: #e6f7ff;
  border: 1px dashed #409EFF;
}

.el-table__row {
  cursor: move;
  transition: all 0.2s;
  user-select: none;
}

.el-table__row:hover {
  background: #f5f7fa !important;
}

/* 拖拽手柄样式 */
.el-table__row .drag-handle {
  cursor: move;
  color: #909399;
  font-size: 16px;
  padding: 0 8px;
}

.el-table__row:hover .drag-handle {
  color: #409EFF;
}
.detail {
  overflow: hidden;
  width: 80%;
  margin: 2em auto;
}
.re{
  margin-top: 2em;
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 60px;
  right: 20px;
  background-color: white;
  width: 6%;
}
.btn{
  margin-bottom: 1em;
  background-color: rgb(64,158,255);
  color:white;
}
.top-table{
  overflow: hidden;
  width: 100%;
  box-shadow: 0px 0px 12px -2px #ddd;
  margin-bottom: 2em;
}
.el-descriptions {
  width: 90%;
  margin: 2em auto;
}
.el-input{
  width: 80%;
}
.addbtn{
  margin-top: 1em;
  width: 100%;
  height: 6em;
  display: flex;
  justify-content: flex-end;
}
.input-container {
  display: flex;
  justify-content: center;
}
.dot-list {
  margin: 1em 0;
  padding-left: 1.2em;
}
.dot-list li {
  list-style: disc;
  margin: 0.5em 0;
  line-height: 1.6;
  font-size: 18px;
}
.core-features {
  padding: 16px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fafafa;
}

.feature-block {
  margin-bottom: 20px;
}

.feature-block:last-child {
  margin-bottom: 0;
}

.feature-title {
  color: #303133;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #409eff;
}

.feature-list {
  list-style: disc;
  margin: 0;
  padding-left: 20px;
}

.feature-list li {
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 6px;
  color: #606266;
}

.core-feature-editor {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 12px;
  background-color: #fafafa;
}

.feature-item {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
  background-color: white;
}
</style>
